
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const data = [
  { month: "Jan", value: 4 },
  { month: "Feb", value: -3 },
  { month: "Mar", value: 5 },
  { month: "Apr", value: 10 },
  { month: "May", value: 18 },
  { month: "Jun", value: 8 },
  { month: "Jul", value: -1 }
];

const SmoothLineChart = () => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="value"
          stroke="#00C4CC"
          strokeWidth={3}
          dot={{ fill: "#00C4CC", r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SmoothLineChart;
